import { TextToSubscribeDescriptionElement } from "@redotech/redo-content-builder-common/element-schema";
import { SUBSCRIBE_DESCRIPTION } from "@redotech/redo-marketing-common/signup-form/signup-form";
import { memo } from "react";
import { getBaseElementStyles } from "./base-element-styles";
import { FormElementProps } from "./index";

export const TextToSubscribeDescription = memo(
  function TextToSubscribeDescription({
    element,
  }: Pick<FormElementProps<TextToSubscribeDescriptionElement>, "element">) {
    const baseStyles = getBaseElementStyles(element);

    return (
      <div
        style={{
          ...baseStyles,
          fontFamily: `'${element.fontFamily}'`,
          color: element.textColor,
          fontSize: "8px",
        }}
      >
        {SUBSCRIBE_DESCRIPTION}
      </div>
    );
  },
);
